<template>
  <div
    :class="{ 'intro': isIntro }"
    class="fullscreen preloader-container"
  >
    <div v-if="isIntro" class="preloader-intro" :class="{ 'big': isIntroBig }">
      <img class="eye center-absolute" :src="preloaderGifNoStar" />
      <img
        v-for="(star, index) in stars"
        class="star"
        :src="starImg"
        :key="index"
        :style="{
          left: star.x + 'px',
          top: star.y + 'px',
          'animation-duration': star.duration}"
      />
    </div>
    <div v-else class="preloader">
      <img class="center-absolute" :src="preloaderGif" />
      <h4 class="text-align-center">
        {{
          ($root.allLanguages && $root.allLanguages[$language.current].loading)
            ? $root.allLanguages[$language.current].loading
            : 'LOADING'
        }}
      </h4>
    </div>
  </div>
</template>

<script>
import starImg from '@/assets/img/little-star.png'

import preloaderGif from '@/assets/img/preloader.gif'
import preloaderGifNoStar from '@/assets/img/preloader-nostars.gif'

export default {
  mounted () {
    this.$events.on('preloaderIntro', () => { this.isIntro = true })
    this.$events.on('preloaderNormal', () => { this.isIntro = false })
    this.$events.on('preloaderBig', () => { this.isIntroBig = true })
    this.$events.on('preloaderSmall', () => { this.isIntroBig = false })
  },
  props: {
    isIntro: {
      type: Boolean,
      default: false
    },
    isBig: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      starImg,
      preloaderGif,
      preloaderGifNoStar,
      isIntroBig: false,
      stars: [
        { x: -40, y: -80, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -85, y: -50, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -120, y: -80, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -110, y: -20, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 30, y: -90, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 115, y: -70, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 60, y: -60, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 100, y: -20, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -20, y: 80, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -55, y: 60, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -110, y: 80, duration: (6 + (Math.random() * 6)) + 's' },
        { x: -100, y: 20, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 130, y: 10, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 85, y: 30, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 30, y: 70, duration: (6 + (Math.random() * 6)) + 's' },
        { x: 70, y: 90, duration: (6 + (Math.random() * 4)) + 's' }
      ]
    }
  },
  watch: {
    isBig (value) {
      this.isIntroBig = value
    }
  }
}
</script>

<style lang="scss" scoped>
.preloader-container {
  z-index: 100;
  background-color: $c-pink;

  &.intro {
    pointer-events: none;
    background-color: transparent;
  }
}

.preloader-intro {
  position: absolute;
  top: 50%;
  left: 50%;
  transition: transform 1s;

  &.big {
    transform: scale(1.6);

    @include breakpoint ('sm-and-down') {
      transform: scale(1.25);
    }
  }

  .eye {
    width: 180px;
  }
}

.preloader {
  img {
    width: 180px;
  }

  h4 {
    position: absolute;
    top: 50%;
    left: 50%;
    font-weight: lighter;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    transform: translate(-50%, 80px);
  }
}

.star {
  width: 15px;
  position: absolute;
  animation-name: hop;
  animation-iteration-count: infinite;
}

@keyframes hop {
  0% {
    transform: translate(0, 0) scale(1);
  }

  17% {
    transform: translate(2px, -10px) rotate(0deg);
  }

  33% {
    transform: translate(4px, 0) scale(0.7);
  }

  50% {
    transform: translate(-2px, -7px) rotate(175deg);
  }

  66% {
    transform: translate(-4px, -0) scale(1);
  }

  84% {
    transform: translate(-2, -5px) rotate(120deg);
  }

  100% {
    transform: translate(0, 0) rotate(144deg);
  }
}
</style>
